/**
 * holiday-modal.js
 * Shows a holiday notice modal once per browser session.
 * The modal cannot be dismissed by clicking the backdrop —
 * only by checking the box and pressing the enter button.
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'holiday_modal_seen';

  function init() {
    // Already seen in this session — bail out
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    var overlay  = document.getElementById('holiday-modal-overlay');
    var checkbox = document.getElementById('holiday-modal-checkbox');
    var btn      = document.getElementById('holiday-modal-btn');

    if (!overlay || !checkbox || !btn) return;

    // Show the modal with a slight delay so CSS transitions fire
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
    });

    // Toggle button disabled state based on checkbox
    checkbox.addEventListener('change', function () {
      btn.disabled = !this.checked;
    });

    // Dismiss on button click only
    btn.addEventListener('click', function () {
      if (checkbox.checked) {
        dismiss(overlay);
      }
    });

    // Block backdrop clicks from doing anything
    overlay.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // Also prevent keyboard Escape from closing anything
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function dismiss(overlay) {
    sessionStorage.setItem(STORAGE_KEY, '1');
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    setTimeout(function () {
      overlay.style.display = 'none';
    }, 500);
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
